import React from 'react'

const LOCALES = {
  title: {
    de: 'So stimmt Ihre Gemeinde im Vergleich',
    fr: 'Votre commune comparée aux autres'
  },
  lead: {
    de: 'Verteilung der Schweizer Gemeinden nach ihrem Stimmverhalten.',
    fr: 'Distribution des communes suisses selon le résultat de leurs votes.'
  },
  yes: {
    de: 'ja',
    fr: 'oui'
  },
  no: {
    de: 'nein',
    fr: 'non'
  },
  yaxis: {
    de: (
      <>
        <br />
        Anzahl der Gemeinden
      </>
    ),
    fr: (
      <>
        <br />
        Nombre de communes
      </>
    )
  }
}

export default LOCALES
